import React from 'react';
import Text from '../../../../../components_v2/common/Text/Text';

const BtfContent = props => {
  const { data } = props;
  return (
    <>
      {data &&
        data !== '' &&
        data !== undefined && (
          <Text
            text={data}
            // className={data.className}
            background="coronahomepage"
            isdangerouslySetInnerHTML
          />
        )}
    </>
  );
};
export default BtfContent;
